import { GridItemsAlignment, GridJustification, GridProps } from '@material-ui/core';
import { Grid } from '@material-ui/core';
import React from 'react';

export type VerticalGridProps = Omit<GridProps, "align" | "justifyContent" | "container" | "direction"> & {
    align?: GridItemsAlignment
    verticalAlign?: GridJustification
}

export function VerticalGrid ({ align, verticalAlign, ...props }: VerticalGridProps) {
    return (
        <Grid {...props} container direction="column" alignItems={align} justifyContent={verticalAlign} />
    )
}